import React from 'react';
import ImageBase from './ImageBase';
import { ImageChildren } from './ImageChildrenType';
import { TFetchPriorityProps } from './fetchPriority';

type TBasic = {
  alt: string;
  src: string;
  loading?: 'lazy' | 'eager' | 'auto';
  width?: string;
  height?: string;
  className?: string;
  srcSet?: string;
  style?: React.CSSProperties;
  title?: string;
  decoding?: 'async' | 'sync' | 'auto';
  aspectRatio?: 'landscape' | 'portrait' | 'square';
  fit?: boolean;
  children?: ImageChildren;
} & TFetchPriorityProps;

const Basic = ({ aspectRatio = 'square', fit, ...props }: TBasic) => {
  const aspectRatioClass = aspectRatio ? `hz-Image--${aspectRatio}` : '';
  const fitClass = fit ? 'hz-Image--fit' : '';
  const combinedClassName = `${props.className || ''} ${aspectRatioClass} ${fitClass}`.trim();

  return <ImageBase {...props} as="img" className={combinedClassName} />;
};

export default Basic;
